import React, { Component } from "react";
import "../../Controls/ListingPage.css";
import Spinner from "../../../Common/Spinner";
import toastr from "toastr";
import axios from "axios";

const MIN_RECHARGE_USD = 10;

class WhatsAppPayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      amount: MIN_RECHARGE_USD,
      convertedAmount: null,
      selectedGateway: null,
      selectedCurrency: "USD",
      razorpayLoaded: false,
      isLoading: false,
      paymentState: {
        status: null,
        message: "",
        paymentId: null,
      },
    };

    this.gateways = {
      stripe: { name: "Stripe", currencies: ["USD", "INR"], icon: "🛒" },
    };
  }

  componentDidMount() {
    this.loadRazorpay();
    this.convertAmount(this.state.amount, "USD", "INR");
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.amount !== this.state.amount ||
      prevState.selectedCurrency !== this.state.selectedCurrency
    ) {
      if (this.state.selectedCurrency === "USD") {
        this.convertAmount(this.state.amount, "USD", "INR");
      } else {
        this.convertAmount(this.state.amount, "INR", "USD");
      }
    }
  }

  loadRazorpay = () => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => this.setState({ razorpayLoaded: true });
    document.body.appendChild(script);
  };

  convertAmount = async (value, from, to) => {
    try {
      this.setState({ isLoading: true });

      const res = await axios.get(
        `https://open.er-api.com/v6/latest/${from}`
      );
        let rate = 1;
    if (
      res &&
      res.hasOwnProperty("data") &&
      res.data &&
      res.data.hasOwnProperty("rates") &&
      res.data.rates &&
      res.data.rates.hasOwnProperty(to)
    ) {
      rate = res.data.rates[to];
    }

      this.setState({
        convertedAmount: (value * rate).toFixed(2),
      });
    } catch (err) {
      console.error(err);
      toastr.error("Failed to convert currency");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleGatewaySelect = (gateway) => {
    const defaultCurrency = this.gateways[gateway].currencies[0];
    this.setState({
      selectedGateway: gateway,
      selectedCurrency: defaultCurrency,
    });
  };

  handleCurrencyChange = (e) => {
    this.setState({ selectedCurrency: e.target.value });
  };

  handlePayNow = async () => {
    const { selectedGateway, amount, selectedCurrency } = this.state;

    if (!selectedGateway) {
      toastr.warning("Please select payment method");
      return;
    }

    const minAmount =
      selectedCurrency === "USD" ? MIN_RECHARGE_USD : MIN_RECHARGE_USD * 80;

    if (amount < minAmount) {
      toastr.warning(`Minimum recharge is ${minAmount} ${selectedCurrency}`);
      return;
    }

    try {
      this.setState({
        paymentState: { status: "pending", message: "Creating order..." },
      });

      const payload = {
         registrationId: this.props.registration.registration.key,
        amount,
        gateway: selectedGateway,
        currency: selectedCurrency,
        purpose: "whatsapp",
      };

      const resp = await this.props.createOnlinePayment(payload);

      const { razorpayOrderId, checkoutUrl } = resp.data;

      // ✅ STRIPE (NO PACKAGE REQUIRED)
      if (selectedGateway === "stripe") {
        if (!checkoutUrl) {
          toastr.error("Stripe URL not received");
          return;
        }

        // redirect to Stripe Checkout
        window.location.href = checkoutUrl;
      }

      // ✅ RAZORPAY
      else if (selectedGateway === "razorpay") {
        const options = {
          key: resp.data.razorpayKey,
          amount: resp.data.amountInPaise,
          currency: resp.data.currency,
          name: "Whatsapp Wallet Recharge",
          description: "Wallet Top-up",
          order_id: razorpayOrderId,
          theme: { color: "#3399cc" },
        };

        new window.Razorpay(options).open();
      }
    } catch (err) {
      console.error(err);
      toastr.error("Payment failed");
      this.setState({
        paymentState: { status: "failed", message: "Error" },
      });
    }
  };

  render() {
    const {
      amount,
      selectedCurrency,
      selectedGateway,
      convertedAmount,
      isLoading,
      paymentState,
    } = this.state;

    return (
      <div style={{ padding: "20px" }}>
        <div
          style={{
            maxWidth: "500px",
            margin: "0 auto",
            background: "#fff",
            borderRadius: "20px",
            padding: "20px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          }}
        >
          {/* Title */}
          <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
            Add Funds to Your Wallet
          </h2>

          {/* Amount */}
          <label style={{ display: "block", marginBottom: "8px" }}>
            Enter Amount ({selectedCurrency})
          </label>

          <input
            type="number"
            value={amount}
            onChange={(e) =>
              this.setState({ amount: parseFloat(e.target.value) || 0 })
            }
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #ccc",
              marginBottom: "10px",
            }}
          />

          <p style={{ textAlign: "center", color: "#666" }}>
            {isLoading
              ? "Converting..."
              : selectedCurrency === "USD"
              ? `≈ ${convertedAmount} INR`
              : `≈ ${convertedAmount} USD`}
          </p>

          {/* Currency */}
          {selectedGateway &&
            this.gateways[selectedGateway].currencies.length > 1 && (
              <div style={{ marginBottom: "15px", textAlign: "center" }}>
                <select
                  value={selectedCurrency}
                  onChange={this.handleCurrencyChange}
                  style={{ padding: "8px", borderRadius: "8px" }}
                >
                  {this.gateways[selectedGateway].currencies.map((cur) => (
                    <option key={cur}>{cur}</option>
                  ))}
                </select>
              </div>
            )}

          {/* Gateway */}
          <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
            {Object.keys(this.gateways).map((key) => (
              <button
                key={key}
                onClick={() => this.handleGatewaySelect(key)}
                style={{
                  flex: 1,
                  padding: "15px",
                  borderRadius: "10px",
                  border:
                    selectedGateway === key
                      ? "2px solid green"
                      : "1px solid #ccc",
                  background:
                    selectedGateway === key ? "#e6ffe6" : "#f9f9f9",
                  cursor: "pointer",
                }}
              >
                {this.gateways[key].icon} {this.gateways[key].name}
              </button>
            ))}
          </div>

          {/* Pay Button */}
          <button
            onClick={this.handlePayNow}
            disabled={!selectedGateway || isLoading}
            style={{
              width: "100%",
              padding: "15px",
              borderRadius: "10px",
              background:
                !selectedGateway || isLoading ? "#ccc" : "green",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            {isLoading ? "Processing..." : `Pay ${selectedCurrency} ${amount}`}
          </button>

          {/* Status */}
          {paymentState.status && (
            <div style={{ marginTop: "15px", textAlign: "center" }}>
              {paymentState.status === "success"
                ? "✅ Payment Successful"
                : paymentState.status === "failed"
                ? "❌ Payment Failed"
                : "⏳ Pending"}
            </div>
          )}
        </div>

        {this.state.loading && <Spinner />}
      </div>
    );
  }
}

export default WhatsAppPayment;